<template>
  <div class="card">

    <div class="card card-custom" >
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('box.list') }}</h3>
        </div>
        <div class="card-toolbar">
          <a href="#" v-if="$can('box_create')"   @click.prevent="openCreateModal" class="btn btn-sm btn-primary">{{ $t('box.create') }}</a>
        </div>

      </div>

      <div class="card-body" >
        <table class="table align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_box" style="margin-top: 13px !important; cursor:pointer">
          <thead>
          <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th> {{$t("box.name")}}</th>
            <th>{{$t("actions")}}</th>
          </tr>
          </thead>
        </table>
      </div>
      <create></create>
    </div>

    <div class="modal fade" tabindex="-1" id="boxModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('button.add') }}</h5>

            <!--begin::Close-->
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
              <!--end::Svg Icon-->
            </div>
            <!--end::Close-->
          </div>

          <div class="modal-body">
            <!--begin:Form-->
            <form id="kt_modal_new_target_form" @submit.prevent="createBoxData" class="form" >

              <div class="d-flex flex-column mb-8 fv-row">
                <!--begin::Label-->
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{$t('box.name')}}</span>
                </label>
                <!--end::Label-->
                <input type="text" class="form-control form-control-solid" v-model="formCreateData.name" :placeholder="$t('box.name_placeholder')" required />
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                <button type="submit" id="kt_submit_create_box" class="btn btn-sm btn-primary fw-bolder">
                  <span class="indicator-label">{{ $t('button.save') }}</span>
                  <span class="indicator-progress">{{  $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                </button>
              </div>
            </form>
            <!--end:Form-->
          </div>


        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" id="editModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('button.edit') }}</h5>

            <!--begin::Close-->
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
              <!--end::Svg Icon-->
            </div>
            <!--end::Close-->
          </div>

          <div class="modal-body">
            <!--begin:Form-->
            <form id="kt_modal_new_target_form" @submit.prevent="updateBoxData" class="form" >

              <div class="d-flex flex-column mb-8 fv-row">
                <!--begin::Label-->
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{$t('box.name')}}</span>
                </label>
                <!--end::Label-->
                <input type="text" class="form-control form-control-solid" v-model="formEditData.name" :placeholder="$t('box.name')" required />
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                <button type="submit" id="kt_submit_edit_box" class="btn btn-sm btn-primary fw-bolder">
                  <span class="indicator-label">{{ $t('button.save') }}</span>
                  <span class="indicator-progress">{{  $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                </button>
              </div>
            </form>
            <!--end:Form-->
          </div>


        </div>
      </div>
    </div>
    <!--end::Card body-->
  </div>
</template>

<script>
import {BASE_URL} from "@/services/api";
import {mapActions} from "vuex";
import {nextTick} from "vue";

export default {
  data(){
    return{
      formCreateData: {
        shop_id: this.$route.params.id,
        name: '',
      },
      formEditData: {
        id: null,
        name: '',
        row: null
      },
      formDeleteData: {
        id: null,
        row: null
      },
      isLoading: false,
    }
  },
  async mounted(){
    await this.loadPermissions()
    this.fetchDatas()
    $(document).on("click", "#kt_datatable_box .edit_btn", (e) => {
      this.formEditData.id = e.target.getAttribute('data-id')
      this.formEditData.name = e.target.getAttribute('data-name')
      $('#editModal').modal('toggle')
    });

    $(document).on("click", "#kt_datatable_box .delete_btn", (e) => {
      this.formDeleteData.id = e.target.getAttribute('data-id')
      this.deleteBoxRow()
    });
  },
  watch:{
    '$i18n.locale' : function(value){
      if(value && this.table){
        nextTick(() => {
          this.fetchDatas()
        })
      }
    },
    '$route.params.id'(newId, oldId){
      // Vue Router réutilise ce composant quand on passe de la fiche d'une
      // boutique à une autre (même route, seul :id change) — sans ce watcher,
      // la datatable garde les caisses de l'ancienne boutique consultée.
      if (newId && newId !== oldId) this.fetchDatas()
    },
  },
  methods: {
    ...mapActions('permission', [
        'loadPermissions'
    ]),

    fetchDatas(){
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_box").DataTable({
        destroy:true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 0, 'asc']],
        ajax: {
          url: `${BASE_URL}/get/shop/${this.$route.params.id}/boxes/datatables`,
          type: "GET",
          beforeSend: (request) => {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          }
        },
        columns: [{ data: "name" }, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [

          {
            targets: -2,
            render:  (t, a, e, l) => {
              return '<span >' + t + "</span>";
            },
          },
          {
            width: "20%",
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render=""
              if(this.$can('box_update')  ){
                render+='<a href="javascript:;" data-id="'+ e.id +'" data-name="'+ e.name +'"   class="btn btn-sm btn-clean btn-icon   edit_btn" title="'+ i18n.global.t('button.edit') +'"><i   data-id="'+ e.id +'" data-name="'+ e.name +'"   class="la la-edit fs-2"></i></a>'

              }
              if(this.$can('box_delete')  ){
                render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-row="'+ l.row +'" data-id="'+ e.id +'" class="la la-trash fs-2"></i></a>'

              }

              return render

            },
          },

        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
        }
      });
    },

    openCreateModal(){
      $('#boxModal').modal('toggle')
    },
    ...mapActions('boxes', [
      'createBoxe',
      'updateBoxe',
      'deleteBoxe'
    ]),

    async createBoxData(){
      this.$loading('kt_submit_create_box')

      let response = {}

      try{
        response = await this.createBoxe(this.formCreateData)
        window.toastr['success'](i18n.global.t("notification.box_created"))
        this.table.ajax.reload()
        $('#boxModal').modal('toggle')
        this.formCreateData = {
          shop_id: this.$route.params.id,
          name: '',
        }
        this.$stopLoading('kt_submit_create_box')
        return true

      }catch(err){
        this.$stopLoading('kt_submit_create_box')
        return true
      }
    },
    async updateBoxData(){
      this.$loading('kt_submit_edit_box')
      let response = {}

      try{
        response = await this.updateBoxe(this.formEditData)

        window.toastr['success'](i18n.global.t("notification.box_updated"))
        this.table.ajax.reload()
        $('#editModal').modal('toggle')
        this.$stopLoading('kt_submit_edit_box')
        return true

      } catch(err){
        this.$stopLoading('kt_submit_edit_box')
        this.isLoading = false;
      }
    },
    async deleteBoxRow() {
      Swal.fire({
        title: i18n.global.t('swal.box'),
        text: i18n.global.t('swal.text'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: i18n.global.t('swal.yes'),
        cancelButtonText: i18n.global.t('swal.no'),
      }).then(async (result) => {
        if (result.value) {

          try {

            await this.deleteBoxe(this.formDeleteData.id)
            window.toastr['success'](i18n.global.t("notification.box_deleted"))
            this.table.ajax.reload()

          } catch (e) {
            console.log(e)
          }
        }
      });
    },
  }
}
</script>

